import { useSetState } from 'ahooks';
import { useState } from 'react';

// 搜索框状态处理
export const useUserActionsSearchBox = (props?: { [key: string]: unknown; }) => {
  const initialPageCfg = {
    page: 1,
    page_size: 10,
    ...(props || {}),
  };
  const [keyword, setKeyword] = useState<string | null>(null);
  const [pageCfg, setPageCfg] = useSetState(initialPageCfg);
  // 搜索回调
  const handleOnSearchBox = <S extends string>(text: S) => {
    const keyword = text?.trim()?.toLowerCase();
    setPageCfg(initialPageCfg);
    setKeyword(keyword);
  };
  // 搜索文本输出
  const handleOnChangeSearchBox = (...[text]: Parameters<typeof handleOnSearchBox>) => {
    const keyword = text?.trim()?.toLowerCase();
    setKeyword(keyword);
    if (!text) {
      setPageCfg(initialPageCfg);
    }
  };
  // 搜索清空回调
  const handleOnClearAllSearchBox = () => {
    setKeyword(null);
    setPageCfg(initialPageCfg);
  };
  // 分页回调
  const handleOnPagingChange = (query: { pageIndex: number; pageSize: number; }) => {
    const { pageIndex, pageSize } = query;
    setPageCfg(() => ({ page: pageIndex, page_size: pageSize }));
  };
  return {
    keyword,
    pageCfg,
    handleOnSearchBox,
    handleOnChangeSearchBox,
    handleOnClearAllSearchBox,
    handleOnPagingChange,
  };
};
